<template>
  <div style="display: flex;flex-direction: column">
    <FindJobIntroduce/>
    <ShowJob/>
  </div>

</template>

<script>
import FindJobIntroduce from "@/components/FindJobIntroduce.vue";
import ShowJob from "@/components/ShowJob.vue";

export default {
  name: 'HomeContent',
  components: {ShowJob, FindJobIntroduce}
};
</script>
